import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DraggableColumn from '../sidebar/columns/DraggableColumn';
import { MenuItem, Skeleton, Stack, SvgIcon, Typography } from '@mui/material';
import { Cancel, Create } from '@mui/icons-material';
import { tagListItem } from '../../config/pdfReportConfig';
type props = {
  item: tagListItem;
  index: number;
  onEdit: (item: tagListItem) => void;
  onRemove: (item: tagListItem) => void;
  charLimit: number;
  isLoading: boolean;
  displayName: string;
  disabled?: boolean;
};
export const DraggableTag = ({
  item,
  onEdit,
  onRemove,
  charLimit,
  isLoading,
  displayName,
  disabled,
}: props) => {
  const { inputId } = item;

  const id = inputId;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
  };
  return (
    <div ref={setNodeRef} style={style} data-sm={displayName}>
      {isLoading ? (
        <Skeleton variant="rectangular" />
      ) : (
        <DraggableColumn
          id={id}
          dragHandleProps={disabled ? {} : { ...attributes, ...listeners }}
          renderContextItems={
            disabled
              ? undefined
              : () => (
                  <>
                    <MenuItem onClick={() => onEdit(item)}>
                      <Stack alignItems="center" gap="2px" flexDirection="row">
                        <SvgIcon component={Create} />
                        <Typography variant="body2">Edit</Typography>
                      </Stack>
                    </MenuItem>
                    <MenuItem onClick={() => onRemove(item)}>
                      <Stack alignItems="center" gap="2px" flexDirection="row">
                        <SvgIcon color="error" component={Cancel} />
                        <Typography color="error" variant="body2">
                          Remove
                        </Typography>
                      </Stack>
                    </MenuItem>
                  </>
                )
          }
        >
          <Typography fontWeight="600" color="primary" variant="body2">
            {displayName.slice(0, charLimit) + (displayName.length > charLimit ? '...' : '')}
          </Typography>
        </DraggableColumn>
      )}
    </div>
  );
};
